module.exports = __webpack_public_path__ + "static/media/dante devil form for shadow.dfc3eae5.png";